(() => {
  const paintingSortLabel = 'Painting date, newest first';

  const shouldUsePaintingSort = () => {
    if (!window.location.pathname.replace(/\/$/, '').startsWith('/collections/')) return false;

    const sortBy = new URLSearchParams(window.location.search).get('sort_by');
    return sortBy === null || sortBy === '' || sortBy === 'manual';
  };

  const insertPaintingOption = () => {
    if (!window.location.pathname.replace(/\/$/, '').startsWith('/collections/')) return;

    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      let option = select.querySelector('option[value="manual"]');

      if (!option) {
        option = document.createElement('option');
        option.value = 'manual';
        select.prepend(option);
      }

      option.textContent = paintingSortLabel;
      option.selected = shouldUsePaintingSort();
    });
  };

  const parsePaintingDate = (value) => {
    if (!value) return null;

    const normalized = value.toString().trim();
    if (!normalized) return null;

    const isoDate = normalized.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (isoDate) {
      return Number(isoDate[1]) * 10000 + Number(isoDate[2]) * 100 + Number(isoDate[3]);
    }

    const monthMatch = normalized.match(
      /\b(january|february|march|april|may|june|july|august|september|october|november|december)\b/i
    );
    const yearMatches = normalized.match(/\b(19|20)\d{2}\b/g);
    if (!yearMatches) return null;

    const year = Number(yearMatches[yearMatches.length - 1]);
    if (!monthMatch) return year * 10000;

    const months = [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ];
    const month = months.indexOf(monthMatch[1].toLowerCase()) + 1;

    return year * 10000 + month * 100;
  };

  const sortGrid = () => {
    insertPaintingOption();

    if (!shouldUsePaintingSort()) return;

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    items
      .sort((a, b) => {
        const aDate = parsePaintingDate(a.dataset.paintingDate);
        const bDate = parsePaintingDate(b.dataset.paintingDate);
        const aHasDate = Number.isFinite(aDate);
        const bHasDate = Number.isFinite(bDate);

        if (aHasDate && bHasDate && aDate !== bDate) return bDate - aDate;
        if (aHasDate !== bHasDate) return aHasDate ? -1 : 1;

        const aTitle = a.querySelector('.card__heading a')?.textContent.trim() || '';
        const bTitle = b.querySelector('.card__heading a')?.textContent.trim() || '';

        return aTitle.localeCompare(bTitle);
      })
      .forEach((item, index) => {
        item.style.setProperty('--animation-order', index + 1);
        grid.appendChild(item);
      });

    const collectionSection = grid.closest('[data-collection-handle]');
    const collectionHandle = collectionSection?.dataset.collectionHandle;
    if (!collectionHandle) return;

    const collectionPath = window.location.pathname.match(/^\/collections\/[^/?#]+/)?.[0] || `/collections/${collectionHandle}`;
    const navigationItems = items
      .map((item) => {
        const link = item.querySelector('.card__heading a[href*="/products/"]');
        if (!link) return null;

        const productHandle = new URL(link.href).pathname.match(/\/products\/([^/?#]+)/)?.[1];
        const title = link.textContent.trim();
        if (!productHandle || !title) return null;

        return {
          handle: decodeURIComponent(productHandle),
          title,
          url: `${collectionPath}/products/${productHandle}`,
        };
      })
      .filter(Boolean);

    if (!navigationItems.length) return;

    try {
      localStorage.setItem(
        `rlewisstudio:collection-navigation:${collectionHandle}`,
        JSON.stringify({
          collectionPath,
          products: navigationItems,
        })
      );
    } catch (_error) {
      return;
    }
  };

  document.addEventListener('DOMContentLoaded', sortGrid);
  document.addEventListener('collection:grid-updated', sortGrid);
  window.addEventListener('popstate', sortGrid);
})();
